import { DefaultOptionType } from 'antd/es/select';
import {localize} from "mixins/helpers";

export const periodData = (translations): DefaultOptionType[] => [
    {
        value: 0,
        label: localize('stats-external-monthly', translations),
    },
    {
        value: 1,
        label: localize('stats-external-quarterly', translations),
    },
    {
        value: 2,
        label: localize('stats-external-annually', translations),
    },
];

export const externalPeriodData = (translations): DefaultOptionType[] => [
    {
        label: localize('stats-external-monthly', translations),
        value: 0,
    },
];

export const exportPeriodData = (translations): DefaultOptionType[] => [
    {
        label: localize('stats-external-monthly', translations),
        value: 0,
    },
    {
        label: localize('stats-external-annually', translations),
        value: 2,
    },
];

export const blocks = (translations): DefaultOptionType[] => [
    {
        label: localize('stats-external-1-quart', translations),
        value: '1q',
    },
    {
        label: localize('stats-external-2-quart', translations),
        value: '2q',
    },
    {
        label: localize('stats-external-3-quart', translations),
        value: '3q',
    },
    {
        label: localize('stats-external-4-quart', translations),
        value: '4q',
    },
];

export const hsCodes = (translations): DefaultOptionType[] => [
    {
        label: localize('all', translations),
        value: 'All',
    },
    {
        label: localize('stats-external-commodity-nomenclature-4', translations),
        value: '4z',
    },
    {
        label: localize('stats-external-commodity-nomenclature-6', translations),
        value: '6z',
    },
    {
        label: localize('stats-external-commodity-nomenclature-10', translations),
        value: '10z',
    },
];

export enum TypeEnum {
    /**
     * Таможенная статистика внешней торговли
     */
    SVT = 'SVT',
    /**
     * «Таможенная статистика внешней торговли» за год «по Республике Казахстан» или по области/городу - Для РК
     */
    SVT_G = 'SVT_G',
    /**
     * SVT_G_10* - Ежегодно для регионов
     */
    SVT_G_ = 'SVT_G_',
    /**
     * Экпресс-информация по экcпорту
     */
    EXPRESS_EXP = 'EXPRESS_EXP',
    /**
     * Экпресс-информация по импорту
     */
    EXPRESS_IMP = 'EXPRESS_IMP',
    /**
     * Экспорт и импорт в разрезе товар-страна
     */
    TS = 'TS',
    /**
     * Экспорт и импорт в разрезе страна-товар
     */
    ST = 'ST',
}

export const typeData = (translations): DefaultOptionType[] => [
    {
        label: localize('stats-external-customs-statistics', translations),
        value: TypeEnum.SVT,
    },
    {
        label: localize('stats-external-express-export', translations),
        value: TypeEnum.EXPRESS_EXP,
    },
    {
        label: localize('stats-external-express-import', translations),
        value: TypeEnum.EXPRESS_IMP,
    },
    {
        label: localize('stats-external-product-country', translations),
        value: TypeEnum.TS,
    },
    {
        label: localize('stats-external-country-product', translations),
        value: TypeEnum.ST,
    },
];

export const externalTypeData = (translations): DefaultOptionType[] => [
    {
        label: localize('stats-external-customs-statistics', translations),
        value: TypeEnum.SVT,
    },
    {
        label: localize('stats-external-product-country', translations),
        value: TypeEnum.TS,
    },
];

export const regionOrder = [
    '0101',
    '6201',
    '6001',
    '5901',
    '7101',
    '10',
    '0301',
    '0601',
    '0901',
    '1501',
    '1801',
    '7001',
    '2101',
    '33',
    '2701',
    '3001',
    '3901',
    '3301',
    '4301',
    '4501',
    '51',
    '4801',
    '5801',
    '62',
    '7201',
];
